(function(){
"use strict";
const $=(s,c)=>(c||document).querySelector(s), $$=(s,c)=>[...(c||document).querySelectorAll(s)];
const money=n=>'$'+n.toFixed(2), pad=n=>String(n).padStart(2,'0');

/* ── COLOUR ────────────────────────────────────────────────────────────────
   White and Silver are two SEPARATE Shopify products, so each colour carries
   its own variant id, its own gallery and its own bundle prices. Selecting a
   colour swaps all three, and updatesMap() zeroes the other colour's handle so
   a switch can never leave both in the cart.
     white  → product 9192902852862, variant 48085962817790
     silver → product 9364543930622, variant 48573788061950                   */
const CDN='https://gripforgeshop.com/cdn/shop/files/';
const MEDIA_WHITE=[
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gripforge-hero-worldwide.png?v=1788136443&width=1400',alt:'GripForge Trimmer Handle'},
  {t:'vid',src:'https://gripforgeshop.com/cdn/shop/videos/c/vp/716f088cfe804efc83e89b9a862a110f/716f088cfe804efc83e89b9a862a110f.HD-1080p-2.5Mbps-88650076.mp4',poster:'https://gripforgeshop.com/cdn/shop/files/preview_images/716f088cfe804efc83e89b9a862a110f.thumbnail.0000000000.jpg',alt:'GripForge in use'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gf-gallery-1-hq.png?v=1785806912&width=1400',alt:'GripForge handle detail'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gf-gallery-2-hq.png?v=1785806912&width=1400',alt:'Universal clamp'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gf-gallery-3-hq.png?v=1785806911&width=1400',alt:'Adjustable height'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/Ad284_1.jpg',alt:'Trimming upright'},
  {t:'vid',src:'https://gripforgeshop.com/cdn/shop/videos/c/vp/097e1b7d6727415e90cd83aef098eb91/097e1b7d6727415e90cd83aef098eb91.HD-720p-2.1Mbps-81962994.mp4',poster:'https://gripforgeshop.com/cdn/shop/files/preview_images/097e1b7d6727415e90cd83aef098eb91.thumbnail.0000000000.jpg',alt:'Installing GripForge'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gf-gallery-4-hq.png?v=1785806911&width=1400',alt:'GripForge fitted to a trimmer'},
  {t:'img',src:'https://gripforgeshop.com/cdn/shop/files/gf-gallery-5-hq.png?v=1785806912&width=1400',alt:'Aluminium construction'},
  {t:'vid',src:'https://gripforgeshop.com/cdn/shop/videos/c/vp/7d4d73261dc94a798b5721a209a3f19f/7d4d73261dc94a798b5721a209a3f19f.HD-1080p-3.3Mbps-81963316.mp4',poster:'https://gripforgeshop.com/cdn/shop/files/preview_images/7d4d73261dc94a798b5721a209a3f19f.thumbnail.0000000000.jpg',alt:'GripForge on the fence line'}
];
/* Silver gallery — the 7 images off Julian's silver-optimised page
   (/products/gripforge™-trimmer-handle-1). Sources are 1856–3712px wide, so
   &width=1400 is comfortably above the DPR-3 requirement.                     */
const MEDIA_SILVER=[
  {t:'img',src:CDN+'gf-silver-hero-worldwide.jpg?v=1788138130&width=1400',alt:'GripForge Trimmer Handle — silver'},
  {t:'img',src:CDN+'hf_20260711_223535_0228bb42-6b41-4c1c-b789-b9713bd132b0.png?width=1400',alt:'Silver handle in use'},
  {t:'img',src:CDN+'Firefly_3.png?width=1400',alt:'Silver handle detail'},
  {t:'img',src:CDN+'Firefly_22.jpg?width=1400',alt:'Silver handle — universal clamp'},
  {t:'img',src:CDN+'Firefly_23.jpg?width=1400',alt:'Silver handle — adjustable height'},
  {t:'img',src:CDN+'Firefly_24.jpg?width=1400',alt:'Silver handle fitted to a trimmer'},
  {t:'img',src:CDN+'Firefly_25.jpg?width=1400',alt:'Silver handle — aluminium construction'}
];
const HARNESS_RRP=79.99;
const TRASH='<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">'+
  '<path fill="currentColor" d="M9 3h6a1 1 0 0 1 1 1v1h4v2H4V5h4V4a1 1 0 0 1 1-1Zm1 2h4V4h-4v1ZM6 9h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 9Zm4 2v9h1v-9h-1Zm3 0v9h1v-9h-1Z"/></svg>';

/* ── Scarcity numbers ────────────────────────────────────────────────────
   These are marketing figures YOU control — not a live Shopify feed.
   Shopify currently reports 93,637 units on this variant, so there is no
   genuine low-stock number to read. Edit these two values and the bar,
   the "Only N left" line and the % claimed all follow.                     */
const STOCK_LEFT=47,      // starting figure
      STOCK_BATCH=500,    // batch size the % claimed is measured against
      STOCK_FLOOR=11,     // never ticks below this
      STOCK_TICK_MS=55000;// one unit roughly every 55s while the tab is open

/* free-gift emblems — the real Kaching gift images from the live store */
const GIFT={
  ship :{t:'FREE Express Shipping',      img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-images-removebg-preview.png'},
  w5   :{t:'FREE 5 Year Warranty',       img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260418_181258_b758e28a-d8e8-4873-9f74-fd0af75678a6-removebg-preview.png'},
  life :{t:'FREE Lifetime Warranty',     img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260419_190148-removebg-preview_430x_c3708d94-64c8-46ea-880c-650b0675950e.webp'},
  ebook:{t:'FREE "Gardeners Secret" eBook', img:'https://cdn.shopify.com/s/files/1/0804/8554/8286/files/Kaching-Bundles-hf_20260418_175904_23c0cb2a-8ae6-4813-b858-60ab868aa64f-removebg-preview.png'}
};
/* SAVE LABELS MUST EQUAL was − price. Checked 2026-08-10; four were wrong and the
   two tier-1 labels were swapped between the colours (white claimed $20 while
   really saving $25.00; silver claimed $25 while really saving $20.00). All four
   understated, so nothing was oversold — but they were wrong, and the true
   numbers are the better pitch. q2 "BOGO 50% OFF" is exactly 50.0% off white's
   $139.98 RRP, so that one stands. */
const BUNDLES_WHITE=[
  {q:1,label:'Save $25 Instantly!',badge:'Starter Special',name:'One GripForge™ Trimmer Handle',sub:'',price:44.99,was:69.99,gifts:[],harness:59.99},
  {q:2,label:'BOGO 50% OFF',badge:'Most Popular',name:'Two GripForge™ Handle Bundle',sub:'One for your trimmer. One for your edger.',price:69.99,was:139.98,gifts:[GIFT.ship,GIFT.w5],harness:59.99},
  {q:3,label:'Buy 2 Get 1 FREE',badge:'Best Value',name:'GripForge™ Handle Premium Bundle',sub:'Save $114.98 Instantly!',price:94.99,was:209.97,gifts:[GIFT.ship,GIFT.life,GIFT.ebook],harness:59.99}
];
/* SILVER PRICES ARE NOT FREE TEXT — they must equal what Shopify actually bills.
   Kaching's quantity bars are not scoped per product, so a silver line of 2 is
   billed $69.99 and a line of 3 is billed $94.99, exactly like white. Displaying
   Julian's original $64.99/$79.99 overcharged the shopper by $5/$15 at checkout,
   2026-08-06 (later): Julian reaffirmed he wants $64.99 / $79.99 displayed, so
   these are HIS numbers and Kaching MUST be scoped to match them — a silver offer
   with bars 1/2/3 = 39.99/64.99/79.99, and the existing offer restricted to the
   white product. Until that Kaching config exists these two rows overcharge the
   shopper by $5 and $15, so re-verify against /cart.js before publishing.
   Harness stays a flat
   $59.99 for the same page-equals-cart reason. */
/* Silver's q2 was labelled "BOGO 50% OFF", but $64.99 off a $119.98 RRP is 45.8%,
   not 50% — the only label on either colour that OVERSTATED. Relabelled to the true
   saving rather than touching the price. To make "BOGO 50% OFF" literally true the
   silver 2-pack would have to drop to $59.99, which is Julian's call, not a fix. */
const BUNDLES_SILVER=[
  {q:1,label:'Save $20 Instantly!',badge:'Starter Special',name:'One GripForge™ Trimmer Handle',sub:'',price:39.99,was:59.99,gifts:[],harness:59.99},
  {q:2,label:'Save $54.99 Instantly!',badge:'Most Popular',name:'Two GripForge™ Handle Bundle',sub:'One for your trimmer. One for your edger.',price:64.99,was:119.98,gifts:[GIFT.ship,GIFT.w5],harness:59.99},
  {q:3,label:'Buy 2 Get 1 FREE — 3 Handles',badge:'Best Value',name:'GripForge™ Handle Premium Bundle',sub:'Save $99.98 Instantly!',price:79.99,was:179.97,gifts:[GIFT.ship,GIFT.life,GIFT.ebook],harness:59.99}
];
const COLORS={
  white :{key:'white', name:'White',  swatch:'#f4f4f2', variant:48085962817790,
          media:MEDIA_WHITE,  bundles:BUNDLES_WHITE,  rrp:69.99},
  /* Silver sells as REAL Shopify pack variants, so Shopify itself owns the price
     and the page can never disagree with checkout. Each pack goes in as ONE line
     of quantity 1, which is below Kaching's quantity-2 trigger, so its All-products
     bar can never override these. Capped at 3 because only these three packs exist. */
  silver:{key:'silver',name:'Silver', swatch:'#c9ccd1', variant:48573788061950,
          media:MEDIA_SILVER, bundles:BUNDLES_SILVER, rrp:59.99, maxQty:3,
          packs:{1:48573788061950, 2:48695788241150, 3:48695788273918}}
};
/* ── Creator attribution pages ─────────────────────────────────────────────────
   A creator page is a DUPLICATE of the white handle, published link-only, so a
   Kaching bundle can be scoped to that product ALONE and every order of it is
   provably that creator's. gf-pdp.liquid emits GF_PDP_VARIANT on those pages only;
   the main PDP emits nothing and this block is skipped entirely, so its behaviour
   is byte-for-byte unchanged.
   Silver is dropped on a creator page on purpose: silver is a DIFFERENT product, so
   a silver sale here would be billed to the original and the creator would lose the
   credit — the one thing this whole setup exists to prevent.                      */
if(window.GF_PDP_VARIANT){
  COLORS.white.variant = window.GF_PDP_VARIANT;
  if(window.GF_PDP_SILVER){
    COLORS.silver.variant = window.GF_PDP_SILVER.variant;
    COLORS.silver.packs   = window.GF_PDP_SILVER.packs;
  } else {
    /* No paired silver duplicate for this creator page. Silver is a SEPARATE product,
       so leaving the stock one here would bill the sale to the original and the creator
       would lose the credit — drop the swatch instead of leaking it. */
    delete COLORS.silver;
  }
}
const REVIEWS=[
  {img:'https://gripforgeshop.com/cdn/shop/files/e5b25c52eb04d9f69e2232fff76f08c2.jpg',q:"I'm 6'2\" and my back used to be done after 15 minutes of trimming. Now I finish my whole yard standing straight. Should've bought this years ago.",n:'Mike R.'},
  {img:'https://gripforgeshop.com/cdn/shop/files/567efc154766b5ff54b3ead274e4fa3d.jpg',q:"I had back surgery last year and thought my trimming days were over. This handle changed everything. No pain, no breaks, just get the job done.",n:'Jason T.'},
  {img:'https://gripforgeshop.com/cdn/shop/files/57a7698363922302dbe82ceddb04a914.jpg',q:"Bought this for my husband because he complained every single time he trimmed. He's ordered two more for his dad and brother. That tells you everything.",n:'Andrea S.'},
  {img:'https://gripforgeshop.com/cdn/shop/files/081950afacc6841a13198bfb9207d277.jpg',q:"59 years old, 5 acres, bad knees and a worse back. This handle let me finish my whole fence line in one session for the first time in years.",n:'Larry W.'},
  {img:'https://gripforgeshop.com/cdn/shop/files/4ad2935651b88f5549cf3555bde9bc80.jpg',q:"I used to take 3 breaks just to do the front yard. Installed this in 5 minutes and trimmed the whole property straight through. I'm mad I didn't buy it sooner.",n:'Chris D.'},
  {img:'https://gripforgeshop.com/cdn/shop/files/8d7354f416ad18e5069412b0cee1df70.jpg',q:"Got this for my dad after his back surgery. He called me the same day to say it's the best gift I've ever gotten him. Ordering one for myself now.",n:'Layla M.'}
];
const FAQS=[
  ['Will this fit my specific trimmer brand?','Yes. GripForge\'s universal clamp fits virtually all straight-shaft trimmers. Customers have confirmed it works on Stihl, Echo, DeWalt, Ego, Husqvarna, Milwaukee, Worx, and more.'],
  ['Does it work on both gas and electric trimmers?','Absolutely. Gas or battery-powered, it doesn\'t matter. The clamp fits any standard straight shaft regardless of power source.'],
  ['How does this actually help my back?','Standard trimmers force you to hunch forward to reach the ground. GripForge raises your grip point so you can stand fully upright while trimming. Customers with back surgeries, fusions, and arthritis all report immediate relief from their first use.'],
  ['Can I use it for vertical edging?','Yes, though some customers prefer switching back to the factory handle for precision edging along sidewalks. Most customers keep both handles on and switch between them depending on the task.'],
  ['How long does it take to install?','5 minutes or less. Everything you need comes in the box. Clamp it to your shaft, adjust the height and angle to fit your body, tighten it down, and you\'re ready to go. No extra tools needed.'],
  ['What if I don\'t like it?','No risk. You\'re covered by our 60-day money back guarantee. If it doesn\'t save your back, send it back for a full refund. No questions, no hassle.'],
  ['Will the handle stay in place while I\'m trimming?','Yes. The four-bolt clamp with tightener locks the handle firmly onto your shaft. We recommend giving the tightener a quick check before each use — just like you would with any bolt on equipment that sees vibration. If it ever loosens, a quick tighten takes 10 seconds and you\'re back to work.']
];

/* Handles are tracked PER COLOUR so a cart can hold white and silver at the same
   time, and either can drop to 0 — which is what makes "harness only" possible.
   state.color is just which colour the buy box is currently configuring.        */
/* TWO separate things, deliberately:
     state.sel  = what the buy box is configuring (colour + quantity) — not yet bought
     state.h    = what is actually IN the cart, per colour
   Add to cart ACCUMULATES sel into h, which is what lets someone add a silver,
   then switch to white and add one of those too. Selecting a colour only changes
   the buy box; it never touches the cart. */
const state={sel:1,h:{white:0,silver:0},harness:0,ship:false,warranty:false,color:'white'};
let pendingHarness=0;   // buy-box harness toggle, not yet in the cart
const MAX_QTY=99;
/* Harness is capped at 1. Kaching's quantity bars are scoped to ALL products, so a
   harness line of 2 gets billed $69.99 (the 2-handle bar) instead of $119.98 —
   a ~$50 loss. Capping at 1 makes that state unreachable without touching Kaching.
   If Kaching is ever scoped to the handle products only, raise this to MAX_QTY. */
const MAX_HARNESS=1;
const curQ  = ()=>state.sel;                     // buy-box quantity (pending)
const colMax= ()=>CO().maxQty||MAX_QTY;
const setQ  = n =>{state.sel=Math.max(1,Math.min(colMax(),n));};
const dispQ = ()=>state.sel;
const totalHandles = ()=>state.h.white+state.h.silver;
/* Kaching discounts a LINE by that line's own quantity, so gift tiers follow the
   largest single-colour line — never the sum. 1 white + 1 silver unlocks nothing,
   which is exactly what Shopify charges for it. */
const giftQ = ()=>Math.max(state.h.white,state.h.silver);

/* everything price- and image-related resolves through the active colour */
const CO      = ()=>COLORS[state.color];
const MEDIA   = ()=>CO().media;
const BUNDLES = ()=>CO().bundles;
const HANDLE_RRP = ()=>CO().rrp;

/* Bundle pricing mirrors the live Kaching bars exactly (verified against /cart.js). */
function tier(q,ck){ return (ck?COLORS[ck].bundles:BUNDLES())[Math.min(Math.max(q,1),3)-1]; }
function packPrice(q,ck){
  /* Verified against the live cart 2026-07-31: Kaching prices 1 and 2 off their own
     deal bars, then from 3 up it simply continues the 3-pack unit rate.
     White: qty 4 = $126.65, 5 = $158.32, 6 = $189.98 — matches Shopify to the cent. */
  const B=ck?COLORS[ck].bundles:BUNDLES();
  if(q<=0) return 0;
  return q < 3 ? B[q-1].price : Math.round(q * B[2].price * 100 / 3) / 100;
}
function packWas(q,ck){ return (ck?COLORS[ck].rrp:HANDLE_RRP())*q; }

/* gallery */
const stage=$('#stage'), trail=$('#trail'), dots=$('#dots'); let gi=0;
/* rebuildable so switching colour can swap the whole gallery in place */
function buildGallery(){
  gi=0;
  $$('#stage > img, #stage > video').forEach(el=>el.remove());
  dots.innerHTML=''; trail.innerHTML='';
  MEDIA().forEach((m,i)=>{
    let el;
    if(m.t==='vid'){el=document.createElement('video');el.src=m.src;el.poster=m.poster;el.muted=true;el.loop=true;el.playsInline=true;el.preload='none';}
    else{el=document.createElement('img');el.src=m.src;el.alt=m.alt;el.loading=i?'lazy':'eager';}
    stage.appendChild(el);
    const d=document.createElement('button');d.type='button';d.setAttribute('aria-label','Go to media '+(i+1));
    d.addEventListener('click',()=>go(i)); dots.appendChild(d);
    if(i<10){
      const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','View media '+(i+1));
      b.innerHTML='<img src="'+(m.t==='vid'?m.poster:m.src)+'" alt="" loading="lazy">'+(m.t==='vid'?'<span class="play">▶</span>':'');
      b.addEventListener('click',()=>go(i)); trail.appendChild(b);
    }
  });
  go(0);
}
buildGallery();
function go(i){
  gi=(i+MEDIA().length)%MEDIA().length;
  $$('#stage > img, #stage > video').forEach((el,k)=>{
    const on=k===gi; el.classList.toggle('on',on);
    if(el.tagName==='VIDEO'){ if(on){el.preload='auto';el.play().catch(()=>{});} else el.pause(); }
  });
  $$('#trail button').forEach((b,k)=>b.setAttribute('aria-current',k===gi?'true':'false'));
  $$('#dots button').forEach((b,k)=>b.setAttribute('aria-current',k===gi?'true':'false'));
}
$('#gPrev').addEventListener('click',()=>go(gi-1));
$('#gNext').addEventListener('click',()=>go(gi+1));
/* swipe */
let sx=null;
stage.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});
stage.addEventListener('touchend',e=>{
  if(sx===null)return; const dx=e.changedTouches[0].clientX-sx;
  if(Math.abs(dx)>44) go(gi+(dx<0?1:-1)); sx=null;
},{passive:true});
go(0);

/* bundles — rebuildable so a colour switch reprices every card */
function buildBundles(){
$('#bundles').innerHTML=BUNDLES().map(b=>
  '<div class="bnd" data-q="'+b.q+'" role="radio" tabindex="0" aria-checked="'+(b.q===dispQ())+'">'+
  '<span class="bnd__ribbon">'+b.badge+'</span>'+
  '<div class="bnd__row"><span class="bnd__radio"></span>'+
    '<span class="bnd__mid"><span class="bnd__name">'+b.name+'</span>'+
      (b.sub?'<span class="bnd__sub">'+b.sub+'</span>':'')+
      '<span class="bnd__lbl">'+b.label+'</span></span>'+
    '<span class="bnd__px"><b>'+money(b.price)+'</b><s>'+money(b.was)+'</s><em>'+money(b.price/b.q)+' each</em></span>'+
  '</div>'+
  (b.gifts.length?'<div class="bnd__gifts">'+b.gifts.map(g=>'<span><img src="'+g.img+'" alt="">+ '+g.t+'</span>').join('')+'</div>':'')+
  /* 40x40 in the card (.bnd__ups img), and it renders in ALL THREE bundle cards —
     so a 1200px asset was being pulled three times over for 120px of pixels. */
  '<div class="bnd__ups"><img src="'+thumb('https://gripforgeshop.com/cdn/shop/files/gf-harness-hq.png?v=1785807463',120)+'" alt="">'+
    '<span class="u-t">Add A Shoulder Harness?<small>'+money(b.harness)+' <s>'+money(HARNESS_RRP)+'</s> — takes the weight off your arms'+
      '<a href="#" class="gf-mtview" role="button">Tap to view</a></small></span>'+
    '<span class="chk" role="checkbox" aria-checked="'+(pendingHarness>0)+'" tabindex="0">✓</span></div>'+
  '</div>').join('');
$$('.bnd').forEach(el=>{
  el.addEventListener('click',e=>{ if(e.target.closest('.chk'))return; setQ(+el.dataset.q); render(); });
  el.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();setQ(+el.dataset.q);render();}});
  const c=$('.chk',el);
  const ups=$('.bnd__ups',el);
  if(ups) ups.addEventListener('click',e=>{e.stopPropagation();pendingHarness=pendingHarness?0:1;render();});
  c.addEventListener('click',e=>{e.stopPropagation();pendingHarness=pendingHarness?0:1;render();});
  c.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();e.stopPropagation();pendingHarness=pendingHarness?0:1;render();}});
});
}
buildBundles();

/* ── colour selector ──────────────────────────────────────────────────────
   Swaps gallery + prices + the Shopify variant that gets added to the cart, so
   a silver order lands on the silver product in Shopify, not the white one.   */
function buildColors(){
  const host=$('#gfColors'); if(!host) return;
  host.innerHTML=Object.values(COLORS).map(c=>
    '<button type="button" class="gfc'+(c.key===state.color?' on':'')+'" data-color="'+c.key+'" '+
      'role="radio" aria-checked="'+(c.key===state.color)+'">'+
      '<span class="gfc__sw" style="background:'+c.swatch+'"></span>'+
      '<span class="gfc__n">'+c.name+'</span>'+
      '<span class="gfc__p">from '+money(c.bundles[0].price)+'</span>'+
    '</button>').join('');
  $$('.gfc',host).forEach(b=>b.addEventListener('click',()=>setColor(b.dataset.color)));
}
/* every static handle thumbnail on the page (quick-add row, sticky bar) */
function syncColorImages(){ $$('.gf-colimg').forEach(im=>{im.src=MEDIA()[0].src;}); }
async function setColor(key){
  if(!COLORS[key]||key===state.color) return;
  const prev=state.color;
  state.color=key;
  /* buy-box only — the cart is untouched, so tapping a swatch never changes what
     the shopper already added. (Julian 2026-08-06: tapping Silver must not add.) */
  buildColors(); buildGallery(); buildBundles(); syncColorImages(); render();
}
buildColors(); syncColorImages();

$$('.addon').forEach(a=>a.addEventListener('click',()=>{
  const k=a.dataset.addon;
  if(k==='harness'){
    /* TWO different harness controls share the .addon class, and they mean
       different things. The row inside the cart drawer (.addon--cart) adds to the
       REAL cart. The tier-card checkbox stages it for the next Add to cart.
       ⚠ FIXED 2026-08-10: both used to route to pendingHarness. But the drawer
       row's tick and the drawer's harness line BOTH read state.harness, so
       clicking "Trimmer Shoulder Harness +$59.99" in the cart lit nothing, added
       nothing, and silently pushed the buy-box ATC to $104.98 instead — and that
       drawer row is the ONLY harness control on the page, so the entire $59.99
       upsell was unreachable. state.harness flows into desiredLines(), so this
       now writes to the cart via render() -> syncCart(), exactly like ship and
       warranty already did. */
    if(a.classList.contains('addon--cart')) state.harness = state.harness ? 0 : MAX_HARNESS;
    else pendingHarness = pendingHarness ? 0 : 1;
  } else state[k]=!state[k];
  render();
}));

function lines(){
  const o=[];
  /* one row per colour that has quantity — so a mixed cart shows both, and each
     can be stepped down to zero independently (Julian, 2026-08-06). */
  ['white','silver'].forEach(ck=>{
    const q=state.h[ck]; if(!q) return;
    const C=COLORS[ck], b=tier(q,ck);
    o.push({n:'GripForge™ Trimmer Handle — '+C.name,
            s:(q>3?q+' handles · best bundle price':b.badge),
            p:packPrice(q,ck),was:packWas(q,ck),img:thumb(C.media[0].src,120),
            step:true,ck:ck,qty:q});
  });
  if(state.harness){
    const hb=tier(dispQ()).harness;
    o.push({n:'Trimmer Shoulder Harness',s:money(hb)+' each',p:hb*state.harness,
      was:HARNESS_RRP*state.harness,
      img:thumb('https://gripforgeshop.com/cdn/shop/files/gf-harness-hq.png?v=1785807463',120),
      key:'harness',hstep:true,qty:state.harness});
  }
  if(state.ship)o.push({n:'Shipping Protection',s:'Loss, theft & damage',p:3.99,was:0,img:thumb('https://gripforgeshop.com/cdn/shop/files/checkmark_and_time-removebg-preview.png',120),key:'ship'});
  if(state.warranty)o.push({n:'Lifetime Warranty',s:'Free replacement',p:4.99,was:0,img:thumb('https://gripforgeshop.com/cdn/shop/files/hf_20260419_190148_9e72e7aa-ef87-4aee-bddf-75732cf7b82d-removebg-preview.png',120),key:'warranty'});
  return o;
}
/* ⚠ CART-DRAWER THUMBNAILS MUST BE ASKED FOR AT THUMBNAIL SIZE.
   `.ci img` renders at 44x44, but these were the FULL-SIZE product images — measured
   live 2026-08-29: the handle's drawer thumb was 1856x2304 and **5,754 KB** for a
   44px box. That is why the drawer looked empty for a beat on open: nothing was
   broken, the picture simply had not finished downloading. Same bug already fixed in
   harness.js; gf-v6.js never got it.
   Strips any width= the URL already carries before appending ours, so a Liquid
   `image_url: width: 1400` cannot end up fighting this. */
function thumb(u,w){
  if(!u) return '';
  var clean=String(u).replace(/([?&])width=\d+&?/g,'$1').replace(/[?&]$/,'');
  return clean + (clean.indexOf('?')>-1?'&':'?') + 'width=' + (w||120);
}
const setText=(sel,v)=>{const e=$(sel); if(e) e.textContent=v;};
function render(){
  const q=dispQ(), b=tier(q), L=lines();
  const total=L.reduce((s,l)=>s+l.p,0), wasTotal=L.reduce((s,l)=>s+(l.was||l.p),0), saved=wasTotal-total;

  $$('.bnd').forEach(el=>{
    const on = q<=3 ? +el.dataset.q===q : +el.dataset.q===3;  // >3 keeps the 3-pack tier lit
    el.dataset.on=on?'1':'0'; el.setAttribute('aria-checked',on);
    $('.chk',el).setAttribute('aria-checked',!!pendingHarness);
  });
  $$('.addon').forEach(a=>{const on=!!state[a.dataset.addon];a.dataset.on=on?'1':'0';$('.chk',a).setAttribute('aria-checked',on);});
  // an item already in the cart doesn't need an "add" row — it has a stepper on its line
  let upsShown=0;
  $$('.addon--cart').forEach(a=>{ const on=!!state[a.dataset.addon]; a.style.display=on?'none':''; if(!on)upsShown++; });
  $('#dHarnessPx').textContent='+'+money(b.harness);

  const pct=Math.round((1-packPrice(q)/packWas(q))*100);
  $('#hPrice').textContent=money(packPrice(q));
  $('.was').textContent=money(packWas(q));
  $('.savepill').textContent='Save '+pct+'%';
  $('.gal__save').textContent='Save '+pct+'%';
  /* ⚠ FIXED 2026-08-10: these read the CART (total/wasTotal/saved), but they sit
     directly under the offer boxes labelled "Your total" — so on a fresh page,
     before anything had been added, EVERY tier and BOTH colours showed
     "Your total $0.00" and "You're saving $0.00 today", while the Add to cart
     button beside them showed the correct price. They must price the SELECTED
     offer: what the shopper would pay if they added it right now.
     The drawer keeps using the cart figures (#dTotal / #dSave further down),
     because that one really is the cart. */
  const pendingTotal=packPrice(state.sel,state.color)+(pendingHarness?tier(state.sel).harness*pendingHarness:0);
  const pendingWas  =packWas(state.sel,state.color)+(pendingHarness?HARNESS_RRP*pendingHarness:0);
  $('#tWas').textContent=money(pendingWas);
  $('#tNow').textContent=money(pendingTotal);
  $('#tSaved').textContent="You're saving "+money(Math.max(0,pendingWas-pendingTotal))+' today';
  setText('#atcPrice',money(pendingTotal));
  setText('#sNow',money(pendingTotal));
  setText('#sWas',money(pendingWas));

  // cart lines — the handle carries a quantity stepper that walks the bundle tiers
  $('#dBody').innerHTML=L.map(l=>
    '<div class="ci"><img src="'+l.img+'" alt=""><span class="n">'+l.n+'<small>'+l.s+'</small>'+
    (l.step
      ? '<span class="qty">'+
        /* at qty 1 the minus becomes a delete, so any line can be removed from
           the cart — including the handle, which is what allows harness-only. */
        (l.qty<=1
          ? '<button type="button" class="qty-del" data-del="'+l.ck+'" aria-label="Remove '+l.n+' from cart" title="Remove">'+TRASH+'</button>'
          : '<button type="button" data-qd="-1" data-ck="'+l.ck+'" aria-label="Decrease">−</button>')+
        '<input class="qty-n" type="number" min="1" max="'+MAX_QTY+'" step="1" value="'+l.qty+'" data-qn="'+l.ck+'" aria-label="Quantity">'+
        '<button type="button" data-qd="1" data-ck="'+l.ck+'" aria-label="Increase"'+(l.qty>=MAX_QTY?' disabled':'')+'>+</button></span>'
      : l.hstep
      ? '<span class="qty">'+
        (state.harness<=1
          ? '<button type="button" class="qty-del" data-del="harness" aria-label="Remove harness from cart" title="Remove">'+TRASH+'</button>'
          : '<button type="button" data-hd="-1" aria-label="Decrease harnesses">−</button>')+
        '<input class="qty-n" type="number" min="1" max="'+MAX_QTY+'" step="1" value="'+state.harness+'" data-qn="harness" aria-label="Harness quantity">'+
        '<button type="button" data-hd="1" aria-label="Increase harnesses"'+(state.harness>=MAX_HARNESS?' disabled':'')+'>+</button></span>'
      : '<button type="button" class="ci-rm" data-rm="'+l.key+'">Remove</button>')+
    '</span><span class="p">'+money(l.p)+(l.was?'<s>'+money(l.was)+'</s>':'')+'</span></div>').join('');
  /* delete buttons — drop that line out of the cart entirely */
  $$('#dBody [data-del]').forEach(btn=>btn.addEventListener('click',()=>{
    const k=btn.dataset.del;
    if(k==='harness') state.harness=0; else state.h[k]=0;
    render();
  }));
  $$('#dBody [data-qd]').forEach(btn=>btn.addEventListener('click',()=>{
    const ck=btn.dataset.ck;
    state.h[ck]=Math.max(0,Math.min(COLORS[ck].maxQty||MAX_QTY,state.h[ck] + +btn.dataset.qd)); render();
  }));
  $$('#dBody .qty-n').forEach(inp=>inp.addEventListener('change',()=>{
    const v=parseInt(inp.value,10);
    if(inp.dataset.qn==='white'||inp.dataset.qn==='silver') state.h[inp.dataset.qn]=Math.max(0,Math.min(MAX_QTY,Number.isFinite(v)?v:1));
    else state.harness=Math.max(0,Math.min(MAX_QTY,Number.isFinite(v)?v:0));
    render();
  }));
  $$('#dBody [data-rm]').forEach(btn=>btn.addEventListener('click',()=>{
    const k=btn.dataset.rm; state[k] = (k==='harness') ? 0 : false; render();
  }));
  $$('#dBody [data-hd]').forEach(btn=>btn.addEventListener('click',()=>{
    state.harness=Math.max(0,Math.min(MAX_HARNESS,state.harness + +btn.dataset.hd)); render();
  }));

  // Free-gift unlock bar — gated on the real Kaching gift tiers, not a made-up
  // shipping threshold. NEVER frame shipping as something they unlock: every
  // GripForge order ships free already, so a "$X away from free shipping" gate
  // is a fake gate. Free shipping is stated unconditionally in .drawer__ship-free.
  const B=BUNDLES(), TOP=B[2].price, gq=giftQ();
  $('#dShipFill').style.width=Math.min(100,Math.round(Math.min(gq,3)/3*100))+'%';
  $('#dShipMsg').innerHTML =
    gq<=1 ? "<b>"+money(B[1].price-B[0].price)+"</b> away from a FREE 5 Year Warranty"
  : gq===2 ? "✓ 2 free gifts unlocked — <b>"+money(TOP-B[1].price)+"</b> more for 2 more"
  :         "🎁 <b>All 4 free gifts unlocked</b> — best price per handle";
  $('#dTier1').classList.toggle('hit',gq>=2);
  $('#dTier2').classList.toggle('hit',gq>=3);

  // "add another handle" quick-add walks to the next bundle tier
  const addBtn=$('#dAddHandle');
  if(q>=MAX_QTY){ addBtn.style.display='none'; }
  else{
    addBtn.style.display='';
    $('#dAddHandlePx').textContent='+'+money(packPrice(q+1)-packPrice(q));
    $('#dAddHandleSub').textContent = q===1 ? 'Unlocks 2 free gifts'
      : q===2 ? 'Unlocks 2 more free gifts'
      : 'Best price per handle';
  }

  // collapse the whole "add to your order" block if there is nothing left to add
  $('.drawer__ups').style.display=(upsShown||q<MAX_QTY)?'':'none';

  $('#dSave').textContent='–'+money(saved);
  $('#dTotal').textContent=money(total);
  const units=q+state.harness+(state.ship?1:0)+(state.warranty?1:0);
  $('#dCount').textContent='· '+units+' item'+(units>1?'s':'');
  syncCart();
}

/* reviews marquee */
const grp='<div class="revmq__grp">'+REVIEWS.map(r=>
  '<article class="rev"><img src="'+r.img+'" alt="Customer photo from '+r.n+'" loading="lazy">'+
  '<div class="rev__b"><div class="rev__s">★★★★★</div><p class="rev__q">'+r.q+'</p>'+
  '<div class="rev__n">'+r.n+' <em>✓ Verified Buyer</em></div></div></article>').join('')+'</div>';
$('#revmq').innerHTML=grp+grp;

/* faq */
$('#faqList').innerHTML=FAQS.map((f,i)=>
  '<div class="q" data-open="0"><button class="q__b" aria-expanded="false" aria-controls="a'+i+'"><span class="ck">✓</span><span>'+f[0]+'</span><span class="cv">+</span></button>'+
  '<div class="q__p" id="a'+i+'"><p>'+f[1]+'</p></div></div>').join('');
$$('.q').forEach(q=>{
  const btn=$('.q__b',q), pane=$('.q__p',q);
  btn.addEventListener('click',()=>{
    const open=q.dataset.open==='1';
    $$('.q').forEach(o=>{o.dataset.open='0';$('.q__p',o).style.maxHeight=null;$('.q__b',o).setAttribute('aria-expanded','false');});
    if(!open){q.dataset.open='1';pane.style.maxHeight=pane.scrollHeight+'px';btn.setAttribute('aria-expanded','true');}
  });
});

const t=$('#mq1'); t.appendChild(t.firstElementChild.cloneNode(true));

(function(){
  const K='gf_deadline_v3';
  let end=+localStorage.getItem(K);
  if(!end||end<Date.now()){end=Date.now()+10*60*1000;localStorage.setItem(K,end);}
  const h=$('#c-h'),m=$('#c-m'),s=$('#c-s');
  (function tick(){
    let d=Math.max(0,end-Date.now());
    if(d===0){end=Date.now()+10*60*1000;localStorage.setItem(K,end);d=10*60*1000;}
    const x=Math.floor(d/1000);
    h.textContent=pad(Math.floor(x/3600));m.textContent=pad(Math.floor(x/60)%60);s.textContent=pad(x%60);
    setTimeout(tick,1000);
  })();
})();

/* stock bar animates in */
(function(){
  const K='gf_stock_v1';
  const numEl=$('#stockN'), pctEl=$('#stockPct'), bar=$('#stockBar');
  let n=parseInt(localStorage.getItem(K),10);
  if(!Number.isFinite(n)||n>STOCK_LEFT||n<STOCK_FLOOR) n=STOCK_LEFT;
  let visible=false;
  function paint(pulse){
    const claimed=Math.max(1,Math.min(99,Math.round(100-(n/STOCK_BATCH*100))));
    numEl.textContent=n;
    pctEl.textContent=claimed;
    if(visible) bar.style.width=claimed+'%';
    if(pulse&&numEl.animate){
      numEl.animate([{transform:'scale(1)'},{transform:'scale(1.28)'},{transform:'scale(1)'}],{duration:520,easing:'cubic-bezier(.16,1,.3,1)'});
    }
  }
  paint(false);
  new IntersectionObserver((es,o)=>{ if(es[0].isIntersecting){ visible=true; paint(false); o.disconnect(); } },{threshold:.4}).observe($('.stock'));
  setInterval(()=>{
    if(document.hidden || n<=STOCK_FLOOR) return;
    n--; try{localStorage.setItem(K,n);}catch(e){}
    paint(true);
  },STOCK_TICK_MS);
})();

const vio=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.isIntersecting)v.play().catch(()=>{});else v.pause();}),{threshold:.4});
$$('.vid video').forEach(v=>vio.observe(v));

const rio=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target);}}),{threshold:.1,rootMargin:'0px 0px -40px'});
$$('.rv').forEach(el=>rio.observe(el));
setTimeout(()=>$$('.rv').forEach(el=>el.classList.add('in')),2500);

const sticky=$('#sticky');
new IntersectionObserver(es=>{sticky.classList.toggle('on',!es[0].isIntersecting&&window.scrollY>600);},{threshold:0}).observe($('.buy'));

const drawer=$('#drawer'), scrim=$('#scrim');
/* Scroll-lock ONLY below 980px. Above it the gallery column is position:sticky,
   and setting overflow:hidden on <body> makes body a scroll container, which
   silently kills sticky — the desktop hero appeared to go blank when the drawer
   opened (Julian, 2026-08-07). Below 980px .gal is already static, so locking is
   safe there, and on desktop the drawer is a side panel so the page behind it
   doesn't need locking at all. */
const LOCK_BELOW=980;
function lockScroll(on){
  if(innerWidth<=LOCK_BELOW) document.body.style.overflow=on?'hidden':'';
  else document.body.style.overflow='';
}
function openCart(){drawer.classList.add('on');scrim.classList.add('on');lockScroll(true);}
function closeCart(){drawer.classList.remove('on');scrim.classList.remove('on');lockScroll(false);}
$('#dAddHandle').addEventListener('click',()=>{ const ck=state.color; state.h[ck]=Math.min(MAX_QTY,state.h[ck]+1); render(); });
$('#openCart').addEventListener('click',openCart);
$('#closeCart').addEventListener('click',closeCart);
scrim.addEventListener('click',closeCart);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});
/* handle id comes from the selected colour; the add-ons are shared products.
   HANDLE_IDS lists both colours so updatesMap() can zero the one not selected. */
const HANDLE_IDS=[48085962817790,48573788061950,48695788241150,48695788273918];
/* a creator page's variant must zero out like any other handle id, or switching
   quantity there would leave a stale line in the cart. */
if(window.GF_PDP_VARIANT && HANDLE_IDS.indexOf(window.GF_PDP_VARIANT)<0) HANDLE_IDS.push(window.GF_PDP_VARIANT);
if(window.GF_PDP_SILVER) Object.keys(window.GF_PDP_SILVER.packs).forEach(function(k){
  var id=window.GF_PDP_SILVER.packs[k]; if(HANDLE_IDS.indexOf(id)<0) HANDLE_IDS.push(id);
});
const VARIANT={harness:48493399408894,ship:48089577554174,warranty:48090564624638};
const handleId=()=>CO().variant;

/* ── Real Shopify cart ───────────────────────────────────────────────────────
   Shopify's Web Pixels runtime emits `product_added_to_cart` from the Ajax Cart
   API, and the Meta pixel (2022329161686609, registered as a Shopify web pixel)
   subscribes to it. If Add to Cart never calls /cart/add.js, Meta never sees an
   AddToCart at all — which is exactly what was happening. So: add for real.
   add.js fires the event; update.js then normalises to absolute quantities so a
   second click can't stack duplicates. We never clear the cart, so a failed
   request can never leave the customer with an empty one.                      */
let cartBusy=false, cartWritten=false, syncTimer=null;
/* What the SERVER cart holds, as last known. null = not yet fetched, so we must
   never assume. Set from the /cart.js probe on load and from every write. */
let serverCartCount=null;

function desiredLines(){
  /* every colour with quantity goes to the cart, so mixed carts are supported */
  const o=[];
  ['white','silver'].forEach(ck=>{
    const q=state.h[ck]; if(q<=0) return;
    const P=COLORS[ck].packs;
    if(P && P[q]) o.push({id:P[q],quantity:1});      // one pack variant, real Shopify price
    else o.push({id:COLORS[ck].variant,quantity:q}); // white: loose handles, Kaching prices them
  });
  if(state.harness) o.push({id:VARIANT.harness,quantity:state.harness});
  if(state.ship)    o.push({id:VARIANT.ship,quantity:1});
  if(state.warranty)o.push({id:VARIANT.warranty,quantity:1});
  return o;
}
function updatesMap(){                      // only our own variants; anything else in the cart is untouched
  const m={}; Object.values(VARIANT).forEach(id=>{m[id]=0;});
  HANDLE_IDS.forEach(id=>{m[id]=0;});       // start both colours at 0, then set what's wanted
  desiredLines().forEach(l=>{m[l.id]=l.quantity;});
  return m;
}
async function postJSON(url,body){
  const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify(body),credentials:'same-origin'});
  if(!r.ok) throw new Error(url+' → '+r.status);
  return r.json();
}
function setBadge(n){ const e=$('#cartCount'); if(e) e.textContent=n; }

async function writeCart(fireAdd){
  const lines=desiredLines();
  /* ⚠ NEVER POST AN EMPTY items ARRAY. /cart/add.js answers 400
     {"description":"Required parameter missing or invalid: items"} and every caller
     downstream throws. Guarding here as well as at the call sites so this cannot be
     reintroduced by a future path that forgets to commit a selection first. */
  if(fireAdd && lines.length){
    await postJSON('/cart/add.js',{items:lines});                             // ← the pixel event
    /* ⚡ SKIP THE SECOND ROUND TRIP WHEN IT PROVABLY CANNOT CHANGE ANYTHING.
       /cart/update.js only exists to ZERO OUT variants the shopper deselected. If
       the server cart was empty before this add, add.js has already produced
       exactly the desired state and update.js is a pure no-op — yet it still costs
       a full round trip. Measured 2026-08-29: add.js 478ms + update.js 611ms =
       1,111ms, and that whole window is the "Working…"/"Adding…" label sitting on
       the button before the express buttons even begin navigating to /checkout.
       Halving it is the single biggest win available on this path.
       `serverCartCount===0` is deliberately strict: it starts null (probe not back
       yet), and null must NOT skip — when we don't know, we do the safe thing.
       The drawer renders from `state`, not from this response, and any later edit
       goes through syncCart() → writeCart(false) → update.js, so the server is
       still reconciled. Nothing downstream depends on the skipped response. */
    if(serverCartCount===0){
      const n=lines.reduce((a,l)=>a+(l.quantity||0),0);
      cartWritten=true; serverCartCount=n; setBadge(n);
      return {item_count:n};
    }
  }
  const c=await postJSON('/cart/update.js',{updates:updatesMap()});
  cartWritten=true; serverCartCount=c.item_count; setBadge(c.item_count);
  return c;
}
function syncCart(){                        // keep the real cart matching the drawer once it exists
  if(!cartWritten) return;
  clearTimeout(syncTimer);
  syncTimer=setTimeout(()=>{ writeCart(false).catch(()=>{}); },350);
}

async function addToCart(btn){
  if(cartBusy) return;
  cartBusy=true;
  /* accumulate the pending selection into the cart */
  state.h[state.color]=Math.min(colMax(),state.h[state.color]+state.sel);
  if(pendingHarness){ state.harness=Math.min(MAX_HARNESS,state.harness+pendingHarness); pendingHarness=0; }
  render();
  const html=btn?btn.innerHTML:null;          // NOT textContent — #atcPrice lives inside this button
  if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
  try{ await writeCart(!cartWritten); }
  catch(e){ /* still show the drawer — never block the customer on a network blip */ }
  finally{
    cartBusy=false;
    if(btn){ btn.disabled=false; btn.innerHTML=html; }
    openCart();
  }
}
$('#atc').addEventListener('click',e=>addToCart(e.currentTarget));
$('#stickyAtc').addEventListener('click',e=>addToCart(e.currentTarget));
fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json())
  .then(c=>{ if(c){ serverCartCount=c.item_count; if(c.item_count) setBadge(c.item_count); } }).catch(()=>{});
/* "More payment options" has to actually reach payment. It was wired to
   addToCart(), so it added a handle and opened the drawer — never showing a
   single extra payment method. The wrench and harness pages both send it to
   checkout; this matches them. */
$('#moreOpts').addEventListener('click',e=>goToCheckout(e.currentTarget));

render();

/* ────────────────────────────────────────────────────────────────
   Shopify checkout. The drawer is the source of truth for what the
   customer configured; on checkout we rebuild the real cart from it
   and hand off to Shopify so every automatic discount still applies.
   ──────────────────────────────────────────────────────────────── */
async function goToCheckout(btn){
  if(cartBusy) return;
  /* ⚠ COMMIT THE BUY-BOX SELECTION BEFORE WRITING — THIS IS WHY EVERY EXPRESS
     BUTTON WAS DEAD. `state.sel` is what the picker SHOWS; `state.h` is what has
     been committed to the cart. addToCart() does `h += sel` before writing;
     goToCheckout() did not. So on a fresh page load desiredLines() read
     h={white:0,silver:0} and POSTed {"items":[]} — Shopify answers
     400 "Required parameter missing or invalid: items", the promise rejects, and
     the shopper got the alert below and stayed on the page.
     Net effect: Shop Pay / Apple Pay / Google Pay / PayPal / More payment options
     all failed UNLESS the shopper had already pressed Add to cart — the one case
     where an express button is pointless. Reproduced live 2026-08-26; selecting a
     bundle did NOT help, because that moves `sel`, never `h`.
     Only commit when nothing is committed yet, so someone who already added a
     handle is never charged for two. */
  if(!state.h.white && !state.h.silver){
    state.h[state.color]=Math.min(colMax(), state.h[state.color]+Math.max(1,state.sel));
    if(pendingHarness){ state.harness=Math.min(MAX_HARNESS,state.harness+pendingHarness); pendingHarness=0; }
    render();
  }
  cartBusy=true;
  const html=btn?btn.innerHTML:null;
  if(btn){ btn.disabled=true; btn.textContent='Working…'; }
  try{
    await writeCart(!cartWritten);          // no clear step — the cart can never end up empty
    window.location.href='/checkout';
  }catch(e){
    cartBusy=false;
    if(btn){ btn.disabled=false; btn.innerHTML=html; }
    alert("Sorry — we couldn't start checkout. Please try again.");
  }
}
$('#dCheckout').addEventListener('click',e=>goToCheckout(e.currentTarget));
$$('[data-wallet], #buyNow').forEach(b=>b.addEventListener('click',e=>goToCheckout(e.currentTarget)));


/* ── Harness "tap to view" lightbox ────────────────────────────────────────
   Swap HARNESS_SHOTS for the real product photography; the first entry is what
   opens by default. Any number of shots works — the thumb row auto-fits.      */
const HARNESS_SHOTS = [
  'https://gripforgeshop.com/cdn/shop/files/gf-harness-hq.png?v=1785807463&width=1200'
];
(function(){
  if(!HARNESS_SHOTS.length) return;
  const ov=document.createElement('div'); ov.id='gf-mt-ov';
  const box=document.createElement('div'); box.id='gf-mt';
  box.setAttribute('role','dialog'); box.setAttribute('aria-modal','true');
  box.setAttribute('aria-label','Trimmer Shoulder Harness photos');
  box.innerHTML='<button id="gf-mt-x" aria-label="Close">&times;</button>'+
    '<p id="gf-mt-title">Trimmer Shoulder Harness<span>Takes the weight off your arms &amp; shoulders</span></p>'+
    '<img id="gf-mt-main" src="'+HARNESS_SHOTS[0]+'" alt="Trimmer Shoulder Harness">'+
    // one shot needs no picker — the strip would just repeat the main image
    (HARNESS_SHOTS.length<2 ? '' :
      '<div id="gf-mt-thumbs">'+HARNESS_SHOTS.map((u,i)=>
        '<img class="'+(i?'':'on')+'" data-shot="'+u+'" src="'+u+'" alt="Harness photo '+(i+1)+'" loading="lazy">').join('')+
      '</div>');
  document.body.appendChild(ov); document.body.appendChild(box);

  let lastFocus=null;
  const open=()=>{lastFocus=document.activeElement;ov.classList.add('on');box.classList.add('on');
    document.getElementById('gf-mt-x').focus();};
  const close=()=>{ov.classList.remove('on');box.classList.remove('on');if(lastFocus)lastFocus.focus();};
  ov.addEventListener('click',close);
  document.getElementById('gf-mt-x').addEventListener('click',close);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&box.classList.contains('on'))close();});
  box.querySelectorAll('#gf-mt-thumbs img').forEach(t=>t.addEventListener('click',()=>{
    document.getElementById('gf-mt-main').src=t.dataset.shot;
    box.querySelectorAll('#gf-mt-thumbs img').forEach(z=>z.classList.remove('on'));
    t.classList.add('on');
  }));
  // capture phase so the upsell row's own toggle never fires from this link
  document.addEventListener('click',e=>{
    const v=e.target.closest('.gf-mtview');
    if(v){ e.preventDefault(); e.stopPropagation(); open(); }
  },true);
})();

})();